import { BOOKING_URL } from "@/config/site";

const struggles = [
  { icon: "ri-brain-line", label: "Anxiety & Worry" },
  { icon: "ri-fire-line", label: "Burnout & Exhaustion" },
  { icon: "ri-heart-3-line", label: "Relationship Strain" },
  { icon: "ri-road-map-line", label: "Life Transitions" },
  { icon: "ri-emotion-sad-line", label: "Grief & Loss" },
  { icon: "ri-thunderstorms-line", label: "Emotional Overwhelm" },
];

export default function StrugglesCTA() {
  return (
    <section className="relative py-24 md:py-36 overflow-hidden">
      {/* Background */}
      <div className="absolute inset-0">
        <img
          src="/images/cta1.jpg"
          alt="Peaceful forest path"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-[#418b86]/80 via-[#418b86]/75 to-[#418b86]/80"></div>
      </div>

      <div className="relative z-10 max-w-4xl mx-auto px-6 md:px-10 text-center">
        {/* Eyebrow */}
        <p className="text-[#7ec8e3] text-xs font-medium tracking-widest uppercase mb-6">You're Not Alone</p>

        {/* Headline */}
        <h2 className="text-3xl md:text-5xl font-light text-white leading-tight mb-6" style={{ fontFamily: "'Playfair Display', serif" }}>
          You Don't Have to<br />
          <span className="font-semibold italic">Figure This Out Alone.</span>
        </h2>

        <p className="text-white/80 text-base md:text-lg leading-relaxed mb-12 max-w-2xl mx-auto">
          Whether it's anxiety, burnout, or a season of change — clarity and support are closer than you think. Many people come to us feeling exactly like this:
        </p>

        {/* Struggle Tags */}
        <div className="flex flex-wrap justify-center gap-3 mb-14">
          {struggles.map((item) => (
            <div
              key={item.label}
              className="flex items-center gap-2 bg-white/10 backdrop-blur-sm border border-white/20 text-white/90 text-sm px-4 py-2 rounded-full"
            >
              <i className={`${item.icon} text-[#7ec8e3]`}></i>
              {item.label}
            </div>
          ))}
        </div>

        {/* CTA Button */}
        <a
          href={BOOKING_URL}
          target="_blank"
          rel="noopener noreferrer"
          className="inline-flex items-center gap-3 bg-[#7ec8e3] hover:bg-white text-[#418b86] font-medium px-8 py-4 rounded-full transition-all duration-200 cursor-pointer whitespace-nowrap text-sm"
        >
          <span className="w-8 h-8 flex items-center justify-center rounded-full bg-[#418b86]/20">
            <i className="ri-calendar-line text-sm"></i>
          </span>
          SCHEDULE A CONSULTATION
          <i className="ri-arrow-right-up-line text-base"></i>
        </a>

        <p className="text-white/50 text-xs mt-5">Free 20-minute initial consultation. No commitment required.</p>
      </div>
    </section>
  );
}
